/**
 * This class represents an authentication of the api service.
 * Each authentication has a token which will be transmitted in each
 * service call of the api. A token expires after 1 hour and must be refreshed.
 */
export class Authentication {
    private username: String;
    private password: String;
    private token: String;
    private expiresAt: number;

    /**
     * Constructor of authentication object
     * @param username username of user
     * @param password password of user
     * @param token [optional] token of authentication
     */
    constructor(username: String, password: String, token?: String) {
        this.username = username;
        this.password = password;

        if (token) {
            this.setToken(token);
        }
    }

    /**
     * This function sets the username
     * @param username username of user
     */
    public setUsername(username: String): void {
        this.username = username;
    }

    /**
     * This function returns the username
     * @return username of user (probably email)
     */
    public getUsername(): String {
        return this.username;
    }

    /**
     * This sets the password for this credential
     * @param password password for user
     */
    public setPassword(password: String): void {
        this.password = password;
    }

    /**
     * This function returns the password
     * @return password of user (unhashed)
     */
    public getPassword(): String {
        return this.password;
    }

    /**
     * This function sets the actual token of this user and resets the expiresAt to 1 hour after
     * @param token token of user for authentication on system
     */
    public setToken(token: String): void {
        this.token = token;

        // Set expiresAt 1 hour after calling this function
        const date: Date = new Date();
        this.expiresAt = date.getTime() + (60 * 60 * 1000); // Time in milliseconds
    }

    /**
     * This function returns the actual token
     */
    public getToken(): String {
        return this.token;
    }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/models/authentication.ts